import { modalsHide } from 'actions';
import ConfirmModal from 'components/Modals/ConfirmModal';
import { useDispatch } from 'react-redux';
import { useAcceptAlternativeBidOfferMutation } from 'services/api/alternative-offers';

type Props = {
  vehicleId: number;
  offerAmount: number;
};

export const ConfirmAcceptBuyerOfferModal = ({ vehicleId, offerAmount }: Props) => {
  const [acceptMutation] = useAcceptAlternativeBidOfferMutation();
  const dispatch = useDispatch();
  const handleSubmit = async () => {
    await acceptMutation(vehicleId);
    dispatch(modalsHide(`accept-alternative-offer-${vehicleId}`));
  };

  return (
    <ConfirmModal
      title={`Are you sure you want to accept buyer's offer? Vehicle will be sold for ${offerAmount}`}
      handleSubmit={handleSubmit}
      submitText={'Accept'}
      modalId={`accept-alternative-offer-${vehicleId}`}
    />
  );
};
